<template>
  <iconsWrapper :width="width" :height="height" :viewBox="viewBox">
    <path
      d="M19.25 5.48177C16.1975 5.17927 13.1267 5.02344 10.065 5.02344C8.25 5.02344 6.435 5.1151 4.62 5.29844L2.75 5.48177"
      stroke="#012464"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      fill="none"
    />
    <path
      d="M7.79163 4.55551L7.99329 3.35467C8.13996 2.48384 8.24996 1.83301 9.79913 1.83301H12.2008C13.75 1.83301 13.8691 2.52051 14.0066 3.36384L14.2083 4.55551"
      stroke="#012464"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      fill="none"
    />
    <path
      d="M17.2792 8.37793L16.6833 17.6088C16.5825 19.0479 16.5 20.1663 13.9425 20.1663H8.05749C5.49999 20.1663 5.41749 19.0479 5.31666 17.6088L4.72083 8.37793"
      stroke="#012464"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      fill="none"
    />
    <path
      d="M9.46912 15.125H12.5216"
      stroke="#012464"
      stroke-width="1.5"
      stroke-linecap="round"
      fill="none"
    />
    <path
      d="M8.70837 11.458H13.2917"
      stroke="#012464"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      fill="none"
    />
  </iconsWrapper>
</template>

<script>
import iconsWrapper from '@/components/icons/iconsWrapper.vue';
export default {
  name: 'IconDelete',
  components: {
    iconsWrapper,
  },
  props: {
    iconColor: {
      type: String,
      default: 'currentColor',
    },
    width: {
      type: [Number, String],
      default: 22,
    },
    height: {
      type: [Number, String],
      default: 22,
    },
    viewBox: {
      type: String,
      default: '0 0 22 22',
    },
  },
};
</script>
